export default __webpack_public_path__ + "static/media/np_language_3325116_000000.633e0007.svg";